import { render, staticRenderFns } from "./ModalEditOptionPrices.vue?vue&type=template&id=3d1a947e"
import script from "./ModalEditOptionPrices.vue?vue&type=script&lang=js"
export * from "./ModalEditOptionPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports